<template>
    <div class="swiper-relatedproducts myRelatedProductsSwiper">
        <div class="swiper-wrapper">
            <div v-for="item in Cart.RelatedProducts" :key="item.Id" class="swiper-slide" onclick="window.location = '';" style="cursor:pointer;">
                <div class="inner">
                    <picture>
                        <!--<source media="(max-width: 768px)" srcset="@item.ImageMobile">-->
                        <img :src="item.Image">
                    </picture>
                    <div class="text">
                        <!--<p class="bestfor">
                            @item.BestForLabel: <span class="bestforvalue">@item.BestForValue</span>
                        </p>-->
                        <p class="model">{{item.Name}}</p>
                        <p class="price">
                            {{item.PriceToFormat}}
                            <span v-if="item.PriceOriginalToFormat != null && item.PriceOriginalToFormat.length > 0">
                                <span class="sr-only">Original price: </span>
                                <span class="oldprice">{{item.PriceOriginalToFormat}}</span>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="swiper-button-next swiper-button-next-relatedproduct"></div>
        <div class="swiper-button-prev swiper-button-prev-relatedproduct"></div>
    </div>
</template>
<script>
    import cartMixin from '../mixins/cart-mixin.js';
    import generalMixin from '../mixins/general.js';
    export default {
        name: 'RelatedProducts',
        mixins: [cartMixin,generalMixin],
        template: '#related-products-template',
        data: function () {
            return {

            }
        },
        methods: {
        },
        computed: {
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-cart-parameters').dataset.interfacetexts);
        }
    }
</script>
